import { Outlet } from "react-router-dom";
import classes from "./MyPageApp.module.css";
import MyPageAppNavigation from "./MyPageAppNavigation";

function MyPageAppRootLayout() {
    return (
        <div className={`container ${classes.my_page_container}`}>
            <MyPageAppNavigation />
            <section>
                <div className={classes.mypage_contents}>
                    <Outlet />
                </div>
            </section>
        </div>
    );
}

export default MyPageAppRootLayout;
